import type { FC, RefObject } from 'react';
import type { Store } from 'redux';
import type { ReactReduxContextInstance } from 'react-redux--next/es/components/Context';
import { connect, type ConnectedComponent } from '@atlassian/jira-react-redux/src/index.tsx';
import mapDispatchToProps from './command.tsx';
import mapStateToProps from './query.tsx';
import { PlanTable as View } from './view.tsx';
import type { Props } from './types.tsx';

export const PlanTable: ConnectedComponent<
	FC<Props>,
	{
		containerRef: RefObject<HTMLDivElement>;
		context?: ReactReduxContextInstance | undefined;
		store?: Store | undefined;
	}
> = connect(mapStateToProps, mapDispatchToProps)(View);
